import MeetingCalendar from "./meeting-calendar";

export default { MeetingCalendar };
